module.exports = __webpack_public_path__ + "img/transfer.032199a2.svg";